import { FlexBox } from "@joonapp/web-shared"
import { GroupChannel } from "@sendbird/uikit-react/GroupChannel"
import { useCallback, useEffect, useRef } from "react"

import useCoachStore from "./useCoachStore"
import { QUERY_KEYS } from "../../constants"
import { useFamilyQuery, useGetMeTabCardQuery } from "../../networking/queries"
import { FamilyQuerySelect } from "../../types"
import { queryClient } from "../../util/queryClient"
import useCareTeam from "../care/useCareTeam"

const CoachSB = () => {
  const { setIsFocused } = useCoachStore()
  const { isLoading: isLoadingChildren } = useFamilyQuery(
    FamilyQuerySelect.CHILDREN
  )
  const { isLoading: isLoadingMeTabCard, isFetching: isFetchingMeTabCard } =
    useGetMeTabCardQuery()
  const { selectedCoachProfile } = useCareTeam()
  const { sendbird_channel_url } = selectedCoachProfile || {}
  const messageInputRef = useRef<HTMLTextAreaElement | null>(null)

  const handleMessageInputFocus = useCallback(() => {
    setIsFocused(true)
  }, [setIsFocused])

  const handleMessageInputBlur = useCallback(
    (e: FocusEvent) => {
      const relatedTarget = e.relatedTarget as HTMLElement
      const isActionButton = relatedTarget?.closest(
        '[data-testid="sendbird-message-input-send-button"]'
      )
      if (!isActionButton) {
        setIsFocused(false)
      }
    },
    [setIsFocused]
  )

  useEffect(() => {
    const setupInputRef = () => {
      const input = document.querySelector(
        "#sendbird-message-input-text-field"
      ) as HTMLTextAreaElement
      if (input) {
        messageInputRef.current = input
        input.addEventListener("focus", handleMessageInputFocus)
        input.addEventListener("blur", handleMessageInputBlur)
        return () => {
          input.removeEventListener("focus", handleMessageInputFocus)
          input.removeEventListener("blur", handleMessageInputBlur)
        }
      }
      return undefined
    }

    const timeoutId = setTimeout(setupInputRef, 100)
    return () => clearTimeout(timeoutId)
  }, [handleMessageInputFocus, handleMessageInputBlur])

  const scrollToBottom = useCallback(() => {
    const messageContainer = document.querySelector(
      ".sendbird-conversation__messages"
    )
    if (messageContainer) {
      messageContainer.scrollTop = messageContainer.scrollHeight
    }
  }, [])

  useEffect(() => {
    const timeoutId = setTimeout(scrollToBottom, 300)
    return () => clearTimeout(timeoutId)
  }, [scrollToBottom, selectedCoachProfile])

  useEffect(() => {
    setTimeout(() => {
      if (!isLoadingMeTabCard && !isFetchingMeTabCard)
        queryClient.invalidateQueries([QUERY_KEYS.ME_TAB_CARD])
    }, 750)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FlexBox
      direction="column"
      align="center"
      wrap={false}
      fullWidth
      style={{
        overflow: "hidden",
        opacity: isLoadingChildren ? 0 : 1,
        pointerEvents: isLoadingChildren ? "none" : "auto",
      }}
    >
      <GroupChannel
        key={sendbird_channel_url}
        channelUrl={sendbird_channel_url || ""}
        disableUserProfile={true}
        renderChannelHeader={() => <></>}
        onBeforeSendUserMessage={(e) => {
          setTimeout(scrollToBottom, 100)
          return e
        }}
      />
    </FlexBox>
  )
}

export default CoachSB
